import { useState } from "react";
import { ChevronDown } from "lucide-react";

const KEY = "ai_settings_open_group";

/** Kumpulan tetapan boleh dilipat (dropdown) - hanya satu terbuka pada satu masa. */
export function useOpenGroup() {
  const [open, setOpen] = useState(() => localStorage.getItem(KEY) || "");
  const toggle = (id) => setOpen((cur) => {
    const next = cur === id ? "" : id;
    localStorage.setItem(KEY, next);
    return next;
  });
  return [open, toggle];
}

export default function AISettingsGroup({ id, icon: Icon, tone = "text-fuchsia-500 bg-fuchsia-50", title, hint, badge, open, onToggle, children }) {
  return (
    <div className={`rounded-2xl border bg-white transition-colors ${open ? "border-fuchsia-200 shadow-sm" : "border-slate-100"}`} data-testid={`ai-settings-group-${id}`}>
      <button type="button" onClick={() => onToggle(id)} aria-expanded={open}
        className="w-full flex items-center gap-2.5 px-3 py-2.5 text-left" data-testid={`ai-settings-group-toggle-${id}`}>
        <span className={`grid place-items-center h-8 w-8 rounded-xl shrink-0 ${tone}`}><Icon className="h-4 w-4" /></span>
        <span className="flex-1 min-w-0">
          <span className="block font-extrabold text-[13.5px] text-slate-800 leading-tight">{title}</span>
          {hint && <span className="block text-[11px] text-slate-400 truncate">{hint}</span>}
        </span>
        {badge != null && <span className="text-[10.5px] font-bold text-slate-500 bg-slate-100 rounded-full px-2 py-0.5 shrink-0" data-testid={`ai-settings-group-badge-${id}`}>{badge}</span>}
        <ChevronDown className={`h-4 w-4 text-slate-400 shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-2 pb-2 space-y-2 animate-in fade-in slide-in-from-top-1 duration-200" data-testid={`ai-settings-group-body-${id}`}>{children}</div>}
    </div>
  );
}
